angular.module('impactx.cxml').controller('CXMLRequestCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'ToolbarService',
    CXMLRequestController
]);

function CXMLRequestController($scope, dataGen, TranslationService, ToolbarService) {

    dataGen.getData($scope, {}, "/cxml/requests/dialog").then(function () {
        ToolbarService.setButtons([]);
    });

    this.doProfileRequest = function () {
        $scope.profileRequestResult = null;
        dataGen.postAsForm({}, {data: $scope.data}, "/cxml/requests/profilerequest").then(function (data) {
            $scope.profileRequestResult = data.data.result;
        });
    }
}
